module.exports = __webpack_public_path__ + "img/1525147840.008de47b.jpg";